import styled from "styled-components";
import { ArrowLeftOnRectangleIcon } from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useAccount } from "~/client/hooks";

const Wrapper = styled.div`
  flex: 1;
  flex-shrink: 0;
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  padding: ${(props) => props.theme.sizes.edge};
  padding-inline: ${(props) => props.theme.sizes.modalEdge};
`;

const Description = styled.div`
  & > p {
    ${(props) => props.theme.styles.textParagraph}
    & {
      color: ${(props) => props.theme.colors.gray200};
      line-height: 20pt;
    }
  }
`;

function Body() {
  const { t } = useT();
  const { disconnect } = useAccount();

  return (
    <Wrapper>
      <Content>
        <Description>
          <p>{t("modalCards.sanction.account.description")}</p>
        </Description>
        <Button
          accent={"warning200"}
          appearance={"solid"}
          isMini
          onClick={disconnect}
          left={ArrowLeftOnRectangleIcon}
          title={t("words.disconnect")}
        />
      </Content>
    </Wrapper>
  );
}

export default Body;
